<template>
  <v-row class="justify-center my-3" no-gutters>
    <v-col class="pa-1" v-for="link in links" :key="link.label" cols="auto">
      <a @click.stop.prevent="visitUrl" :href="link.url" v-if="link.url" class="transition-all text-decoration-none border px-1 text-inherit shadow shadow-gray-400/5 hover:underline hover:shadow-blue-300/50" :class="link.active ? 'rounded-none text-primary hover:text-decoration-none' : 'rounded-lg'">
        <span v-html="link.label" style="font-size: larger;"></span>
      </a>
      <span v-else v-html="link.label"></span>
    </v-col>
  </v-row>
</template>

<script setup>
import { computed } from 'vue'
import { router } from '@inertiajs/vue3'


defineOptions({
  name: 'MkPaginateLinks'
})

const props = defineProps({
  links: {
    required: true,
    type: Array,
  }
})

const filteredArray = computed(() => {
    const arr = props.links
    if (arr.length > 7) {
      const firstThree = arr.slice(0, 3)
      const lastFour = arr.slice(-4)
      return [...firstThree, ...lastFour]
    } else {
      return arr
    }
  })

function visitUrl(event) {
  event.preventDefault()
  const url = event.currentTarget.getAttribute('href')
  if (url) {
    router.visit(url, {
      preserveState: true,
      preserveScroll: true,
    })
  }
}

</script>
